export * from './HighlightedCodeWithTabs';
export { HighlightedCodeWithTabs as default } from './HighlightedCodeWithTabs';
